import { Asset, ScheduleException } from '../../models/asset.model';
import { Booking } from '../../models/booking.model';
import { dayOperatingWindowForDate } from './schedule-pricing.utils';
import { collectOccupiedSlotIndices } from './schedule-occupancy.utils';

export type HeatmapDot = 'green' | 'gray' | 'red' | 'none';

export interface DayHeatmapInput {
  space: Asset;
  dateStr: string;
  date: Date;
  bookings: Booking[];
  exceptions: ScheduleException[];
}

/**
 * Computes mini-calendar dot color for one bookable day.
 * Green = fully free, gray = partial, red = fully occupied, none = closed / no window.
 */
export function heatmapDotForDay(input: DayHeatmapInput): HeatmapDot {
  const { space, dateStr, date, bookings, exceptions } = input;
  const window = dayOperatingWindowForDate(space, date, dateStr);
  if (window.closed || window.totalMin <= 0) return 'none';

  const openSlot  = Math.round(window.openMin / 30);
  const closeSlot = Math.round(window.closeMin / 30);
  const total     = closeSlot - openSlot;
  if (total <= 0) return 'none';

  const occupied = collectOccupiedSlotIndices({
    space,
    date,
    dateStr,
    bookings,
    exceptions,
    openSlot,
    closeSlot,
  });

  if (occupied.size === 0) return 'green';
  if (occupied.size < total) return 'gray';
  return 'red';
}
